<template>
  <div id="admin-client">
    <!-- Password Change Form -->
      <div>
        <div class="title-card"
          v-loading="loading"
          element-loading-background="rgba(0, 0, 0, 0.3)">
          <div class="title-card-top">
            <div class="title-card-top-icon">
              <el-tooltip :content="client.name">
                <el-avatar>{{initials}}</el-avatar>
              </el-tooltip>
            </div>
            <div class="title-card-top-name">
              <router-link
                :to="{name: 'admin-client', params:{ id: client.id }}"
                tag="span" class="client-name link-color">
                {{client.name | defaultValue('---')}}
              </router-link>
              <i class="bi bly-small-up bi-rotate-90"></i>
              <span class="title-card-top-account"
                :key="account.id">
                {{account.name}}
              </span>
              <div class="title-card-top-name-description" v-show="account.description">
                {{account.description | defaultValue('---')}}
              </div>
            </div>
            <div class="title-card-top-actions">
              <!--
                ---------------
                ACCOUNT ACTIONS
                ---------------
              -->
              <el-tooltip content="Edit account details">
                <bly-link-button
                  v-if="acl.admin || acl.clientAdmin || acl.aa"
                  @click.native="openEditDialog"
                  :type="'clear'"><i class="bi bly-edit"></i>
                </bly-link-button>
              </el-tooltip>
              <el-tooltip content="More">
                <bly-link-button :type="'clear'"><i class="bi bly-more bi-rotate-90"></i>
                </bly-link-button>
              </el-tooltip>
            </div>
          </div>
          <div class="title-card-bottom"></div>
        </div>
        <div class="content-wrapper">
          <div class="data-header">
            <div class="data-header-tabs">
              <span class="data-header-tabs-tab"
                :class="tabClass('users')"
                v-if="acl.admin || acl.clientAdmin || acl.aa"
                @click="changeContext('users')">Account Users</span>
              <span class="data-header-tabs-tab"
                :class="tabClass('features')"
                v-if="acl.admin || acl.clientAdmin || acl.aa"
                @click="changeContext('features')">Account Features</span>
              <!--<span class="data-header-tabs-tab"
                :class="tabClass('claims')"
                @click="changeContext('claims')">Client Claims</span>
              -->
            </div>
            <div class="data-header-actions">
              <!-- USERS ACTIONS -->
              <div class="data-header-actions-accounts" v-if="isTabContentVisible('users')">
                <el-tooltip content="Get register URL" >
                  <bly-button :type="'clear'"
                    @click.native="getRegisterUrl()">
                      <i class="bi bly-url"></i>
                  </bly-button>
                </el-tooltip>
              </div>

              <!-- FEATURES ACTIONS -->
              <div class="data-header-actions-accounts" v-if="isTabContentVisible('feature')">
                <el-tooltip content="Create account" >
                  <bly-button
                    :type="'clear'"
                    @click.native="createAccountDialog = true">
                    <i class="bi bly-plus"></i></bly-button>
                </el-tooltip>
                <bly-button :type="'clear'"><i class="bi bly-more bi-rotate-90"></i></bly-button>
              </div>
            </div>
          </div>

          <div class="data-content"
            v-loading="loading"
            element-loading-background="#13191d">
            <!-- FEATURE LIST -->
            <div class="feature-list" v-if="isTabContentVisible('features')">
              <h4>Added Features</h4>
              <div class="data-list-item"
                v-for="item in accountFeatures"
                :key="item.id">
                  <div class="data-list-item-name">
                    <i class="bi" :class="'bly-'+item.feature.name"></i>
                    {{item.feature.name}}
                  </div>
                  <div class="data-list-item-actions">
                    <el-dropdown trigger="click">
                      <bly-link-button :type="'clear'" class="el-dropdown-link">
                        <i class="bi bly-more bi-rotate-90"></i>
                      </bly-link-button>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                          @click.native="removeAccountFeatureMap(item)"
                          icon="bi bly-delete">
                            Remove from account
                          </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
              </div>
              <h4>Avaiable Features</h4>
              <div class="data-list-item"
                v-for="item in notAssignedClientFeatures"
                :key="item.id">
                  <div class="data-list-item-name">
                    <i class="bi" :class="'bly-'+item.name"></i>
                    {{item.name}}
                  </div>
                  <div class="data-list-item-actions">
                    <bly-link-button :type="'clear'" @click.native="addAccountFeatureMap(item)">
                      <i class="bi bly-plus"></i>
                    </bly-link-button>
                  </div>
              </div>
            </div>

            <!-- USER LIST -->
            <div class="user-list" v-if="isTabContentVisible('users')">
              <div class="data-list-item"
                v-for="item in accountUsers"
                :key="item.id">
                  <div class="data-list-item-name">
                    {{item.user.email}} <span class="muted">({{item.user.name}})</span>
                  </div>
                  <div class="data-list-item-actions" >
                    <bly-status-tag
                      v-if="!item.user.isApproved"
                      type="red" size="small">INACTIVE</bly-status-tag>
                    <bly-status-tag
                      v-if="item.user.isApproved"
                      type="green" size="small">ACTIVE</bly-status-tag>
                    <el-tooltip content="Assign permissions and activate user"
                      v-if="!item.user.isApproved">
                      <bly-link-button :type="'clear'"
                        @click.native="openClaimEditor(item.user, true)">
                        <i class="bi bly-check"></i>
                      </bly-link-button>
                    </el-tooltip>
                    <el-tooltip content="Manage permissions" v-if="item.user.isApproved">
                      <bly-link-button :type="'copenClaimEditorlear'"
                        @click.native="openClaimEditor(item.user, false)">
                        <i class="bi bly-permissions"></i>
                      </bly-link-button>
                    </el-tooltip>
                    <el-dropdown trigger="click">
                      <bly-link-button :type="'clear'" class="el-dropdown-link">
                        <i class="bi bly-more bi-rotate-90"></i>
                      </bly-link-button>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                          @click.native="deactivateUser(item.user)"
                          icon="bi bly-close">
                            Deactivate user
                          </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--
        ------------
        EDIT ACCOUNT
        ------------
      -->
      <el-dialog
        :title="'Editing ' + account.name + ' account'"
        :visible.sync="editAccountDialog"
        :close-on-click-modal="false"
        width="420px">
        <div class="dialog-form">
          <el-form :model="accountForm" class="form-dark">
            <el-form-item required>
              <el-col :span="6">
                <el-form-item prop="code" label="Code" disabled>
                  <el-input v-model="accountForm.code" placeholder="Code" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="1"> &nbsp; </el-col>
              <el-col :span="17">
                <el-form-item  prop="name" label="Name" required>
                  <el-input v-model="accountForm.name" placeholder="Account name"></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item required>
              <el-col :span="12">
                <el-form-item  prop="email" label="Email">
                  <el-input v-model="accountForm.email" placeholder="Email address"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="1"> &nbsp; </el-col>
              <el-col :span="11">
                <el-form-item  prop="phoneno" label="Phone">
                  <el-input v-model="accountForm.phoneno"  placeholder="Phone number"></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item prop="description" label="Description">
              <el-input v-model="accountForm.description" placeholder="Description"></el-input>
            </el-form-item>
            <el-form-item prop="address" label="Address">
              <el-input v-model="accountForm.address" placeholder="Address"></el-input>
            </el-form-item>
            <el-form-item prop="website" label="Website URL">
              <el-input v-model="accountForm.website" placeholder="Website"></el-input>
            </el-form-item>
        </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editAccountDialog = false">Cancel</el-button>
          <el-button type="primary" @click="updateAcc()">Save</el-button>
        </span>
      </el-dialog>
      <!--
        ----------------
        EDIT USER CLAIMS
        ----------------
      -->
      <el-dialog
        :title="'Editing permissions'"
        :visible.sync="editUserClaimsDialog"
        :close-on-click-modal="false"
        width="420px">
        <div class="dialog-form" v-if="contextItem.user">
          <el-alert
            type="info"
            effect="dark">
            All claims will be assigned to <strong>{{contextItem.user.name}}</strong> for
            <strong> {{client.name}}</strong>
            client
          </el-alert>
          <br>
          <div class="bly-group" v-for="(feature, id) in contextItem.features" :key="id">
            <el-divider content-position="left"><strong>{{feature.feature.name}}</strong></el-divider>
            <div>
              <div
                class="bly-group-claim"
                v-for="(claim, claimId) in feature.claims"
                :key="id + claimId">
                <div
                  @click="
                  contextItem.claims[id+'.'+claimId].value =
                  !contextItem.claims[id+'.'+claimId].value
                  "
                  class="bly-group-claim-name link">
                    {{claim.name}}
                  <small>
                  {{claim.description}}
                  </small>
                </div>
                <el-switch
                :key="id + claimId + 's'"
                  v-model="contextItem.claims[id + '.' + claimId].value">
                </el-switch>
              </div>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editUserClaimsDialog = false">Cancel</el-button>
          <el-button type="primary" @click="updateUserClaims()">Save</el-button>
        </span>
      </el-dialog>

  </div>
</template>

<script>
import _ from 'lodash';
import Vue from 'vue';
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  props: ['id', 'accountId'],
  data() {
    return {
      error: null,
      activeContext: 'users',
      clientForm: {
        code: 'CT',
        name: 'Cloud Tree',
        description: 'Lorem ipsum - sample company',
        email: 'adrian@cloudtree.pl',
        phoneno: '254 2335 478',
        claimsCanAccess: ['ct'],
        claimsCanEdit: ['ct'],
      },

      featureForm: {
        code: '',
        name: '',
        description: '',
      },

      claimForm: {
        code: '',
        name: '',
        description: '',
        feature: ['sss'],
      },

      accountForm: {},

      // dialogs
      editAccountDialog: false,
      editUserClaimsDialog: false,
      assignUserDialog: false,
      contextItem: {},
      newClaims: {},
    };
  },

  computed: {
    ...mapState({
      userId: (state) => state.userAccount.userId,
      acl: (state) => state.userAccount.aclCurrent,
      isAdmin: (state) => state.userAccount.isAdmin,
      aclEx: (state) => state.userAccount.userPermissions,
      clients: (state) => state.admin.clients,
      client: (state) => state.admin.client,
      clientAccounts: (state) => state.admin.clientAccounts,
      listFeatures: (state) => state.admin.listFeatures.items,
      account: (state) => state.admin.account,
      users: (state) => state.admin.users,
      features: (state) => state.admin.features,
      allClaims: (state) => state.admin.allClaims,
      loading: (state) => state.admin.loading,
    }),

    initials() {
      if (!this.client.name) return '';
      return this.client.name.split(' ').map((n) => n[0]).join('');
    },

    tabClass() {
      return (tab) => {
        const isCurrent = tab === this.activeContext;
        return isCurrent ? 'active' : '';
      };
    },

    accountUsers() {
      const hasUsers = this.account.users && this.account.users.items;
      if (hasUsers) {
        return this.account.users.items.sort((a, b) => a.user.name.localeCompare(b.user.name));
      } else {
        return [];
      }
    },

    accountFeatures() {
      const hasFeatures = this.account.features && this.account.features.items;
      return hasFeatures ? this.account.features.items : [];
    },

    clientFeatures() {
      const hasFeatures = this.client.features && this.client.features.items;
      return hasFeatures ? this.client.features.items : [];
    },

    accountFeaturesMap() {
      const featuresMap = {};
      if (!this.account.features) return {};
      this.account.features.items.forEach((item) => {
        featuresMap[item.feature.code] = this.features[item.feature.code];
      });
      return featuresMap;
    },

    notAssignedFeatures() {
      return this.listFeatures.filter((feature) => {
        const isAssigned = !!_.find(this.accountFeatures, ['feature.id', feature.code]);
        return !isAssigned;
      });
    },

    notAssignedClientFeatures() {
      return this.client.features.items.filter((featureMap) => {
        const isAssigned = !!_.find(this.accountFeatures, ['feature.id', featureMap.feature.code]);
        return !isAssigned;
      }).map((featureMap) => featureMap.feature);
    },

    isTabContentVisible() {
      return (tab) => {
        const isCurrent = tab === this.activeContext;
        return isCurrent;
      };
    },

    isDefaultAccount() {
      return this.account.code === this.client.code;
    },
  },

  watch: {
    accountId(newVal) {
      this.init(null, newVal);
    },
    id(newVal) {
      this.init(newVal, null);
    },
  },

  mounted() {
  },

  created() {
    this.init(this.id, this.accountId);
  },

  beforeDestroy() {
    this.clearAccount();
  },

  methods: {
    ...mapActions({
      updateClient: 'admin/updateClient',
      updateAccount: 'admin/updateAccount',
      updateUser: 'admin/updateUser',
      fetchClientDetails: 'admin/fetchClientDetails',
      deleteAccountFeatureMap: 'admin/deleteAccountFeatureMap',
      mapFeatureToAccount: 'admin/mapFeatureToAccount',
      createUserClaimMap: 'admin/createUserClaimMap',
    }),
    ...mapMutations({
      setCurrentClientId: 'admin/setCurrentClientId',
      setUserClient: 'userAccount/setClient',
      clearAccount: 'admin/clearAccount',
      setAccountId: 'admin/setAccountId',
      setUserAccountById: 'userAccount/setAccountById',
    }),

    changeContext(context) {
      this.activeContext = context;
    },

    async init(id, accountId) {
      this.setAccountId(accountId);
      if (id) {
        const result = await this.fetchClientDetails(id);
        this.setUserClient(result);
      }

      if (accountId) {
        this.setUserAccountById(accountId);
      }
    },

    getRegisterUrl() {
      this.$alert(`${window.location.origin}/#/register/${this.client.code}:${this.account.code}`, 'Copy url below', {
        confirmButtonText: 'OK',
        type: 'info',
        center: true,
      });
    },

    async saveClient() {
      const newClient = {
        id: this.client.id,
        name: this.client.name,
        description: this.client.description,
        email: this.client.email,
        phoneno: this.client.phoneno,
        expectedVersion: this.client.version,
        website: this.client.website,
        address: this.client.address,
      };

      await this.updateClient(newClient);
      this.editClientDialog = false;
    },

    async updateAcc() {
      await this.updateAccount(this.accountForm);
      this.editAccountDialog = false;
    },

    async updateUserClaims() {
      let singleMutations = _.map(this.contextItem.claims, (claimInfo) => {
        // detect changes
        const hasChanged = claimInfo.value !== claimInfo.defaultValue;
        const toRemove = hasChanged && !!claimInfo.claimMapId;
        const toAdd = hasChanged && !claimInfo.claimMapId;

        // prepere data
        const accountId = this.account.id;
        const clientId = this.client.id;
        const userId = this.contextItem.user.id;
        const { claimId } = claimInfo;
        const { claimMapId } = claimInfo;

        const createUserClaimMapInput = {
          userClaimMapClaimId: claimId,
          userClaimMapUserId: userId,
          claimsCanAccess: [`usr.${accountId}.${clientId}`],
          claimsCanEdit: [`ca.${accountId}.${clientId}`, `aa.${accountId}.${clientId}`],
          userClaimMapLastUpdatedById: this.userId,
        };
        const deleteUserClaimMapInput = {
          id: claimMapId,
        };

        let input = null;
        if (toAdd) input = createUserClaimMapInput;

        if (toRemove) input = deleteUserClaimMapInput;

        return {
          input,
          toRemove,
          toAdd,
        };
      });
      singleMutations = _.filter(singleMutations, (item) => !!item.input);

      const result = await this.createUserClaimMap(singleMutations);

      if (this.contextItem.shouldApprove) {
        this.activateUser(this.contextItem.user);
      }
      Vue.set(this, 'contextItem', { user: {} });
      this.editUserClaimsDialog = false;
    },

    async deactivateUser(user) {
      const newUser = {
        id: user.id,
        name: user.name,
        email: user.email,
        isApproved: false,
        expectedVersion: user.version,
        claimsCanEdit: user.claimsCanEdit,
        claimsCanAccess: user.claimsCanAccess,
      };
      const result = await this.updateUser(newUser);
      user.isApproved = false;
    },

    async activateUser(user) {
      const newUser = {
        id: user.id,
        name: user.name,
        email: user.email,
        isApproved: true,
        expectedVersion: user.version,
        claimsCanEdit: user.claimsCanEdit,
        claimsCanAccess: user.claimsCanAccess,
      };
      const result = await this.updateUser(newUser);
      user.isApproved = true;
    },

    openClaimEditor(user, shouldApprove) {
      this.context = user;

      Vue.set(this, 'contextItem', {});
      Vue.set(this.contextItem, 'claims', JSON.parse(JSON.stringify(this.allClaims)));
      const userFeatures = JSON.parse(JSON.stringify(this.accountFeaturesMap));
      user.claims.items.forEach((claim) => {
        const featureCode = claim.claim.feature.code;
        const claimCode = claim.claim.code;
        if (claim.id) {
          this.contextItem.claims[`${featureCode}.${claimCode}`].defaultValue = true;
          this.contextItem.claims[`${featureCode}.${claimCode}`].value = true;
          this.contextItem.claims[`${featureCode}.${claimCode}`].claimMapId = claim.id;
        }
      });

      Vue.set(this.contextItem, 'user', user);
      Vue.set(this.contextItem, 'shouldApprove', shouldApprove);
      Vue.set(this.contextItem, 'features', userFeatures);

      // Hide Client Admin Claim for not default accounts
      if (!this.isDefaultAccount && this.contextItem.features.adm) delete this.contextItem.features.adm.claims.ca;
      // this.newClaims
      // this.features.
      this.editUserClaimsDialog = true;
    },

    openAssignUser() {
      this.assignUserDialog = true;
    },

    openEditAccountDialog(account) {
      this.accountForm = {
        id: account.id,
        code: account.code,
        name: account.name,
        description: account.description,
        email: account.email,
        phoneno: account.phoneno,
        expectedVersion: account.version,
        website: account.website,
        address: account.address,
        claimsCanAccess: account.claimsCanAccess,
        claimsCanEdit: account.claimsCanAccess,
        accountLastUpdatedById: this.userId,
      };
      this.editAccountDialog = true;
    },

    openEditClientDialog(client) {
      this.clientForm = {
        id: client.id,
        code: client.code,
        name: client.name,
        description: client.description,
        email: client.email,
        phoneno: client.phoneno,
        expectedVersion: client.version,
        website: client.website,
        address: client.address,
        claimsCanAccess: [client.code],
        claimsCanEdit: [client.code],
      };
      this.editClientDialog = true;
    },

    async addAccountFeatureMap(feature) {
      const clientId = this.client.id;
      const featureId = feature.id;
      const accountId = this.account.id;
      const createAccountFeatureMap = {
        accountFeatureMapAccountId: accountId,
        accountFeatureMapFeatureId: featureId,
        claimsCanAccess: [`usr.${accountId}.${clientId}`],
        claimsCanEdit: [`ca.${accountId}.${clientId}`, `aa.${accountId}.${clientId}`],
        accountFeatureMapLastUpdatedById: this.userId,
      };
      await this.mapFeatureToAccount(createAccountFeatureMap);
      return null;
    },

    async removeAccountFeatureMap(featureMap) {
      const isConfirm = await this.showPrompt(`Are you sure you want to remove <b>${featureMap.feature.name}</b> from  <b>${this.account.name}</b>?`);
      if (!isConfirm) return false;
      await this.deleteAccountFeatureMap(featureMap.id);
      return null;
    },

    async showPrompt(confirmationMessage) {
      const confirmation = await this.$confirm(confirmationMessage, 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true,
        dangerouslyUseHTMLString: true,
      });

      const isConfirmed = confirmation === 'confirm';
      return isConfirmed;
    },

    displayResult(result, errorMessage, successMessage) {
      if (result.error) {
        this.$message({
          showClose: true,
          message: errorMessage,
          type: 'error',
        });
        return;
      }

      this.$message({
        showClose: true,
        message: successMessage,
        type: 'info',
      });
    },

    openEditDialog() {
      this.accountForm = {
        id: this.account.id,
        code: this.account.code,
        name: this.account.name,
        description: this.account.description,
        email: this.account.email,
        phoneno: this.account.phoneno,
        expectedVersion: this.account.version,
        website: this.account.website,
        address: this.account.address,
        claimsCanAccess: this.account.claimsCanAccess,
        claimsCanEdit: this.account.claimsCanEdit,
        accountLastUpdatedById: this.userId,
      };
      this.editAccountDialog = true;
    },
  },
};
</script>

<style>


.el-loading-spinner svg {
  margin: 0 auto;
}

#admin-client {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 20px;
  padding-top: 0;
}
#admin-client .bly-group {
  margin-bottom: 30px;
}
#admin-client .bly-group .el-divider--horizontal {
  margin: 24px 0 16px 0;
}
#admin-client .bly-group .el-divider__text.is-left {
  margin-bottom: 5px;
  color: #000;
}
#admin-client .bly-group-claim {
  display: grid;
  grid-template-columns: auto 40px;
  grid-gap: 24px;
  margin-bottom: 16px;
  align-items: center;
}
#admin-client .bly-group-claim-name {
  color: #000;
  font-weight: 400;
}
#admin-client .bly-group-claim-name small {
  display: block;
  opacity: 0.6;
}
</style>
